import React from 'react'
import OmowienieZasad from './OmowienieZasad'
import MetodyWyceny from './MetodyWyceny'
import UstalenieWynikuFinansowegoOrazSposobuSporzadzenia from './UstalenieWynikuFinansowegoOrazSposobuSporzadzenia'

export default function PolitykaRachunkowosciSkrocona(props) {
  return (
    <>
      <OmowienieZasad
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
      <MetodyWyceny
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
      <UstalenieWynikuFinansowegoOrazSposobuSporzadzenia
        data={props.data}
        errors={props.errors}
        onSetSectionData={props.onSetSectionData}
        czyPodsumowanie={props.czyPodsumowanie}
      />
    </>
  )
}
